export enum TransactionType {
  SubscriptionCreated = 'SubscriptionCreated',
  SubscriptionPaid = 'SubscriptionPaid',
  SubscriptionFailed = 'SubscriptionFailed',
  SubscriptionCanceled = 'SubscriptionCanceled',
  SubscriptionExpired = 'SubscriptionExpired',
  SubscriptionDeleted = 'SubscriptionDeleted',
  SubscriptionRefunded = 'SubscriptionRefunded',
  SinglePayment = 'SinglePayment'
}



// WEBPACK FOOTER //
// ./src/app/paymentTransactions/models/TransactionType.ts